import type { VccStatusType } from '../types';
import { isLegacyVccStatus } from '../types';

type RenderHistoryProps = {
  content: string;
};

const RenderHistory = ({ content }: RenderHistoryProps) => {
  return <div className="history-item">{content}</div>;
};

type CardHistoryProps = { status: VccStatusType };

export const CardHistory = ({ status }: CardHistoryProps) => {
  // Only render if status is Legacy format (has history)
  if (!isLegacyVccStatus(status)) {
    return null;
  }

  return (
    <div className="card-history">
      {status.history.map((history) => (
        <RenderHistory content={history} key={history} />
      ))}
    </div>
  );
};
